//import moment from 'moment';  in use

export default {
    data() {
        return {
            currentweek: 0, 
            title: '',       
        }   
    },

    methods: {
        createBarData(arr_ty, arr_py, arr_py3, arr_uy) {

            // console.log(arr_uy) ;
            // console.log(arr_ty.length, arr_py.length, arr_py3.length);
            let xvalues_ty = [], barcolors_ty = [],  bordercolors_ty = [], yvalues_ty = [], maxvalue_ty = 0, maxvalue = 0;
            let yvalues_py = [], barcolors_py = [],  bordercolors_py = [], maxvalue_py=0;
            let yvalues_py3 = [], barcolors_py3 = [],  bordercolors_py3 = [], maxvalue_py3=0;
            let yvalues_uy = [], barcolors_uy = [],  bordercolors_uy = [], maxvalue_uy=0;
            // this.currentweek = this.getCurrentWeekNum();            

            for (let i = 0; i < arr_ty.length; i++) {
                yvalues_ty.push(arr_ty[i].nr_arrivals)
                if (arr_ty[i].nr_arrivals > maxvalue_ty) {
                    maxvalue_ty = arr_ty[i].nr_arrivals;
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                yvalues_py.push(arr_py[i].nr_arrivals)
                if (arr_py[i].nr_arrivals > maxvalue_py) {
                    maxvalue_py = arr_py[i].nr_arrivals; 
                }                
            }

            for (let i = 0; i < arr_py3.length; i++) {
                yvalues_py3.push(arr_py3[i].nr_arrivals)
                if (arr_py3[i].nr_arrivals > maxvalue_py3) {
                    maxvalue_py3 = arr_py3[i].nr_arrivals; 
                }                
            }

            for (let i = 0; i < arr_uy.length; i++) {
                yvalues_uy.push(arr_uy[i].nr_arrivals)
                if (arr_uy[i].nr_arrivals > maxvalue_uy) {
                    maxvalue_uy = arr_uy[i].nr_arrivals; 
                }                
            }

            xvalues_ty = [];
            if(arr_py.length > arr_ty.length){
                if(arr_py3.length > arr_py.length){
                    // vullen n.a.v. arr_py3
                    arr_py3.forEach(x => {xvalues_ty.push(x.week)});
                } else {
                    // vullen n.a.v. arr_py
                    arr_py.forEach(x => {xvalues_ty.push(x.week)});
                }
            } else {
                // vullen n.a.v. arr_ty
                arr_ty.forEach(x => {xvalues_ty.push(x.week)});
            }

            // console.log("x values", xvalues_ty);

            maxvalue = Math.max(maxvalue_ty, maxvalue_py, maxvalue_py3, maxvalue_uy);

            var section = [];
            section[3] = maxvalue;
            section[2] = maxvalue - (maxvalue / 4);
            section[1] = maxvalue - (2 * (maxvalue / 4));
            section[0] = maxvalue / 4;

            var section_py = [];
            section_py[3] = maxvalue_py;
            section_py[2] = maxvalue_py - (maxvalue_py / 4);
            section_py[1] = maxvalue_py - (2 * (maxvalue_py / 4));
            section_py[0] = maxvalue_py / 4;

            var section_py3 = [];
            section_py3[3] = maxvalue_py3;
            section_py3[2] = maxvalue_py3 - (maxvalue_py3 / 4);
            section_py3[1] = maxvalue_py3 - (2 * (maxvalue_py3 / 4));
            section_py3[0] = maxvalue_py3 / 4;            

            var section_uy = [];
            section_uy[3] = maxvalue_uy;
            section_uy[2] = maxvalue_uy - (maxvalue_uy / 4);
            section_uy[1] = maxvalue_uy - (2 * (maxvalue_uy / 4));
            section_uy[0] = maxvalue_uy / 4;

            for (let i = 0; i < arr_ty.length; i++) {
                let found = false;
                for (let t = 0; t < section.length; t++) {
                    if(!found){
                        if(arr_ty[i].nr_arrivals <= section[t]){
                            switch (t) {
                                case 0:
                                    barcolors_ty.push("rgba(50,205,50,0.5)"); // ok  
                                    bordercolors_ty.push("rgb(50,205,50)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_ty.push("rgba(60,179,113,0.5)"); // busy
                                    bordercolors_ty.push("rgb(60,179,113)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_ty.push("rgba(46,139,87,0.5)"); // really busy
                                    bordercolors_ty.push("rgb(46,139,87)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_ty.push("rgba(0,128,0,0.5)"); // insane
                                    bordercolors_ty.push("rgb(0,128,0)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                let found = false;
                for (let t = 0; t < section_py.length; t++) {
                    if(!found){
                        if(arr_py[i].nr_arrivals <= section_py[t]){
                            switch (t) {
                                case 0:
                                    barcolors_py.push("rgba(0,191,255,0.5)"); // ok  
                                    bordercolors_py.push("rgb(0,191,255)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_py.push("rgba(100,149,237,0.5)"); // busy
                                    bordercolors_py.push("rgb(100,149,237)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_py.push("rgba(30,144,255,0.5)"); // really busy
                                    bordercolors_py.push("rgb(30,144,255)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_py.push("rgba(65,105,225,0.5)"); // insane
                                    bordercolors_py.push("rgb(65,105,225)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }            


            for (let i = 0; i < arr_py3.length; i++) {
                let found = false;
                for (let t = 0; t < section_py3.length; t++) {
                    if(!found){
                        if(arr_py3[i].nr_arrivals <= section_py3[t]){
                            switch (t) {
                                case 0:
                                    barcolors_py3.push("rgba(252,214,112,0.5)"); // ok  
                                    bordercolors_py3.push("rgb(243,156,18)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_py3.push("rgba(249,191,59,0.5)"); // busy
                                    bordercolors_py3.push("rgb(235,149,50)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_py3.push("rgba(243,156,18,0.5)"); // really busy
                                    bordercolors_py3.push("rgb(230,126,34)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_py3.push("rgba(230,126,34,0.5)"); // insane
                                    bordercolors_py3.push("rgb(242,120,75)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }             

            for (let i = 0; i < arr_uy.length; i++) {
                let found = false;
                for (let t = 0; t < section_uy.length; t++) {
                    if(!found){
                        if(arr_uy[i].nr_arrivals <= section_uy[t]){
                            switch (t) {
                                case 0:
                                    barcolors_uy.push("rgba(247, 127, 190,0.5)"); // ok
                                    bordercolors_uy.push("rgb(247, 127, 190)"); // ok (persian)
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_uy.push("rgba(222, 93, 131,0.5)"); // busy   (blush)
                                    bordercolors_uy.push("rgb(222, 93, 131)"); // busy  
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_uy.push("rgba(230, 62, 98,0.5)"); // insane
                                    bordercolors_uy.push("rgb(230, 62, 98)"); // insane (paradise pink)
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_uy.push("rgba(255, 0, 127,0.5)"); // really busy
                                    bordercolors_uy.push("rgb(255, 0, 127)"); // really busy (bright)
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }             

            //console.log(yvalues_uy);

            const datasets = [];
            const currentYear = new Date().getFullYear();

            let dataset_element;

            dataset_element = {
                "backgroundColor": barcolors_py3,
                "hoverBackgroundColor": "rgba(249,191,59,0.3)",
                "data": yvalues_py3,
                "borderColor": bordercolors_py3,
                "hoverBorderColor": "rgba(243,156,18,1)",
                "label": "Arrivals " + (currentYear - 2),
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            dataset_element = {
                "backgroundColor": barcolors_py,
                "hoverBackgroundColor": "rgba(70,130,180,0.3)",
                "data": yvalues_py,
                "borderColor": bordercolors_py,
                "hoverBorderColor": "rgba(70,130,180,1)",
                "label": "Arrivals " + (currentYear - 1),
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            dataset_element = {
                "backgroundColor": barcolors_ty,
                "hoverBackgroundColor": "rgba(34,139,34,0.3)",
                "data": yvalues_ty,
                "borderColor": bordercolors_ty,
                "hoverBorderColor": "rgba(34,139,34,1)",
                "label": "Arrivals " + currentYear,
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            dataset_element = {
                "backgroundColor": barcolors_uy,
                "hoverBackgroundColor": "rgba(222, 93, 131,0.3)",
                "data": yvalues_uy,
                "borderColor": bordercolors_uy,
                "hoverBorderColor": "rgba(222, 93, 131,1)",
                "label": "Arrivals " + (currentYear + 1),
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            /*  scales
                hoogste waarde = 633
                633 - 633 mod 100 = 633 - 33 = 600
                600 / 100 = 6
                6 * 100 = 600
                600 + 100 = 700 (afronden naar boven in een 100-tal)
            */

            let xoptions = {
                plugins: {
                    legend: {
                        display: true
                    },
                    datalabels: {
                        formatter: function(value, context){
                            return context !== null ? value === 0 ? '' : '': '';                         
                        }
                    }                                    
                },
                responsive: true,
                maintainAspectRatio: false,
                lineTension: 0,
                scales: 
                { 
                    y : { min: 0, max: this.getMaxValue(maxvalue)}
                },
            };

            let chartData = {
                type: "line",
                data: {
                    labels: xvalues_ty,
                    datasets: datasets,
                },
                options: xoptions,
            };

            return chartData;

        },
        getMaxValue(v){
            if(v - (((v - v%100) / 100) * 100) <= 50)
                return (((v - v%100) / 100) * 100) + 100
            return ((((v + 100) - v%100) / 100) * 100) + 100
        },
        // getCurrentWeekNum(){
        //     var currentDate = new Date();
        //     var startDate = new Date(currentDate.getFullYear(), 0, 1);
        //     var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));                
        //     return Math.ceil(days / 7);
        // },
    }
}